import React from 'react';
import Tabs from 'components/utilities/tabs/Tabs';

// Import helrpes
import { limitsTabs } from './helpers/index';

const LimitsTabs = () => <Tabs tabs={limitsTabs} />;

export default LimitsTabs;
